import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Top Section - Olive Green Background */}
      <div className="footer-top">
        <div className="footer-container">
          <div className="footer-content">
            {/* Left Section */}
            <div className="footer-section">
              <div className="footer-logo">
                <img 
                  src="/glitter-combined-logo.svg" 
                  alt="Glitter Logo" 
                  className="footer-logo-image"
                />
              </div>
              
              <div className="footer-description">
                <p>
                  Your trusted partner for high-quality fabrication and powder coating solutions. Our fully opernational facility 
                  delivers durable, visually appealing finishes with fresh energy and commitment to excellence.
                </p>
              </div>

              <div className="social-links">
                <a href="https://www.facebook.com/share/1B6Y96ex1K/?mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer">
                  <img src="/icons/facebook.svg" alt="Facebook" className="social-icon" />
                </a>
                <a href="https://www.instagram.com/glittermetalcoating/" target="_blank" rel="noopener noreferrer">
                  <img src="/icons/instagram.svg" alt="Instagram" className="social-icon" />
                </a>
                <a href="https://x.com/GlitterMetalCF" target="_blank" rel="noopener noreferrer">
                  <svg className="x-logo" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
                <a href="https://www.tiktok.com/@glittermetalcoating" target="_blank" rel="noopener noreferrer">
                  <img src="/icons/tiktok.svg" alt="TikTok" className="social-icon" />
                </a>
                <a href="https://www.linkedin.com/company/glitter-metal-coating-and-fabrication-llc/" target="_blank" rel="noopener noreferrer">
                  <img src="/icons/linkedin.svg" alt="LinkedIn" className="social-icon" />
                </a>
              </div>
            </div>

            {/* Right Section */}
            <div className="footer-section">
              <h3>Contact Us</h3>
              <div className="footer-contact-info">
                <div className="company-name">
                  <img 
                    src="/g-icon.svg" 
                    alt="Glitter Icon" 
                    className="company-icon"
                  />
                  Glitter Metal Coating & Fabrication L.L.C
                </div>
                <ul className="footer-contact">
                  <li>
                    <img src="/icons/location.svg" alt="Location" className="footer-icon" />
                    <a href="https://www.google.com/maps/place/25%C2%B008'03.0%22N+55%C2%B015'01.8%22E/@25.134173,55.250494,17z" target="_blank" rel="noopener noreferrer">
                      Warehouse 18<br/>33 22nd St, Al Quoz Industrial Area 2<br/>Dubai, United Arab Emirates
                    </a>
                  </li>
                  <li>
                    <img src="/icons/whatsapp.svg" alt="WhatsApp" className="footer-icon" />
                    <a href="https://wa.me/971565689492" target="_blank" rel="noopener noreferrer">+971 56 568 9492</a>
                  </li>
                  <li>
                    <img src="/icons/mobile.svg" alt="Mobile" className="footer-icon" />
                    <a href="tel:+971565689492">+971 56 568 9492</a>
                    <span> / </span>
                    <a href="tel:+971564225232">+971 56 422 5232</a>
                  </li>
                  <li>
                    <img src="/icons/landline.svg" alt="Landline" className="footer-icon" />
                    <a href="tel:+97142867362">+971 4 286 7362</a>
                  </li>
                  <li>
                    <img src="/icons/email.svg" alt="Email" className="footer-icon" />
                    <a href="mailto:info@glittermetalworks.com">info@glittermetalworks.com</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom Section - Beige Background */}
      <div className="footer-bottom">
        <div className="footer-container">
          <p>&copy; 2025 Glitter Metal Coating and Fabrication L.L.C. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 